import React, { useEffect, useState } from 'react';
import './About.css';

const About = () => {
  const [members, setMembers] = useState([]);

  const FIREBASE_FUNCTION_URL = 'us-central1-gsp-website-553a2.cloudfunctions.net';

  const defaultImageURL = 'https://firebasestorage.googleapis.com/v0/b/gsp-photos-1fe98.appspot.com/o/Members%2Fdefault.png?alt=media&token';

  // Fetch the members' data from the JSON file
  useEffect(() => {
    fetch(`https://${FIREBASE_FUNCTION_URL}/getMembers`)
      .then(response => response.json())
      .then(data => {
      setMembers(data);
      })
      .catch(error => {
      console.error('Error fetching events:', error);
      });
  }, []);

  // Helper function to format email based on first and last names
  const formatEmail = (name) => {
    const [firstName, lastName] = name.split(' '); // Assuming names are 'FirstName LastName'
    const formattedEmail = `${firstName}.${lastName}@UTDallas.edu`;
    return formattedEmail;
  };


  return (
    <div className="about-container">
      <h1>MEET OUR TEAM</h1>
      <div className="members-grid">
        {members.map(member => (
          <div key={member.id} className="member-card">
            <img
              src={member.photoURL || defaultImageURL}
              alt={member.name}
              className="member-photo"
            />
            <h2 className="member-name">{member.name}</h2>
            <h3 className="member-designation">{member.designation}</h3>
            <p className="member-email">
              <a href={`mailto:${formatEmail(member.name)}`}>{formatEmail(member.name)}</a>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;
